import React from "react";

import PropTypes from "prop-types";

const CancelIcon = ({ size = "normal", width = 2 }) => {
  const iconSize =
    (size === "small" && "16px") ||
    (size === "normal" && "24px") ||
    (size === "large" && "32px");

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 6 7"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {/* <!-- Generator: Sketch 57.1 (83088) - https://sketch.com --> */}
      <title>cancel Active</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Filter"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Fibre/Desktop/planselectio-Copy-6"
          transform="translate(-506.000000, -513.000000)"
        >
          <g
            id="🧩-Components/Supplementary-elements/Buttons/Close-button/Desktop/Grey/Default"
            transform="translate(504.000000, 511.000000)"
          >
            <g id="Group">
              <g id="close" transform="translate(2.500000, 2.750000)">
                <rect
                  id="Rectangle-path"
                  x="-1.13686838e-13"
                  y="0"
                  width="5"
                  height="5.5"
                ></rect>
                <path
                  d="M0.769230769,0.846153846 L4.23076923,4.65384615"
                  id="c33595e8-181e-4076-a9f0-227b8fdd48ef"
                  stroke="#666666"
                  strokeWidth={width}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M0.769230769,4.65384615 L4.23076923,0.846153846"
                  id="56502c87-b986-44ba-a730-3fc53d646431"
                  stroke="#666666"
                  strokeWidth={width}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

CancelIcon.propTypes = {
  size: PropTypes.oneOf(["small", "normal", "large"]),
};

export default CancelIcon;
